var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWorkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691-611.5h53.5V-665H691v53.5Zm0 158.5h53.5v-53.5H691v53.5Zm0 158.5h53.5V-348H691v53.5Zm-64 118V-202h210.5v-555.5H447v100l-25.5-18V-783H863v606.5H627Zm-530 0V-493l224-159 224 158.83v316.67H378V-348H264v171.5H97Zm25.5-25.5h116v-171.5h165V-202h116v-278L321-618.5 122.5-480v278ZM627-528.5ZM403.5-202v-171.5h-165V-202v-171.5h165V-202Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWorkIcon);
export default __webpack_public_path__ + "static/media/HomeWorkIcon.9af070e4435075dec5964851c896bc8c.svg";
export { ForwardRef as ReactComponent };